import { groupBy } from 'lodash';
import { useSnapshot } from 'valtio';

import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import {
  clearAssetSelection,
  store,
  toggleManufacturer,
  toggleRefrigerationUnitModel,
} from '../store';

function RefrigerationUnitModelsFilterList() {
  const snap = useSnapshot(store);

  const handleToggleManufacturer = (name: string) => () => {
    toggleManufacturer(name);
    clearAssetSelection();
  };

  const handleToggleModel = (id: string) => () => {
    toggleRefrigerationUnitModel(id);
    clearAssetSelection();
  };

  const groups = groupBy(snap.refrigerationUnitModels, 'manufacturer.name');

  return (
    <List sx={{ pt: 0 }} dense>
      {Object.entries(groups).map(([manufacturerName, models]) => (
        <Box key={manufacturerName}>
          <ListItemButton
            sx={{ p: 0, pl: 0.5 }}
            onClick={handleToggleManufacturer(manufacturerName)}
          >
            <ListItemIcon>
              <Checkbox
                disableRipple
                checked={models.some((model) => model.selected)}
              />
            </ListItemIcon>
            <ListItemText primary={models[0].manufacturer.label} />
          </ListItemButton>
          {models.map((model) => (
            <List key={model.name} sx={{ pl: 4 }} disablePadding dense>
              <ListItemButton
                sx={{ p: 0 }}
                onClick={handleToggleModel(model.id)}
              >
                <ListItemIcon>
                  <Checkbox disableRipple checked={model.selected} />
                </ListItemIcon>
                <ListItemText primary={model.name} />
              </ListItemButton>
            </List>
          ))}
          <Divider sx={{ width: '100%' }} />
        </Box>
      ))}
    </List>
  );
}

export { RefrigerationUnitModelsFilterList };
